export default __webpack_public_path__ + "static/media/logo.24cc2b09.png";